import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/business";

// export const List = async (formData) => {
//   const params = new URLSearchParams();

//   for (let [key, value] of formData.entries()) {
//     params.append(key, value);
//   }

//   return await axiosInstance(options).get(`${path}/list?${params.toString()}`);
// };

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const Status = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const getCategories = async () => {
  return await axiosInstance(options).get(`${path}/categories`);
};

export const getSubCategories = async (id) => {
  return await axiosInstance(options).get(`${path}/subcategories/${id}`);
};

export const Edit = async (values) => {
  return await axiosInstance(options).patch(`${path}/edit`, values);
};

export const Delete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete`, { data: { id } });
};

export const toggleVerification = async (id, isVerified) => {
  return await axiosInstance(options).post(`${path}/toggle-verification`, { id, isVerified });
};
